// Shared Leaflet loader: the bundled npm package (BSD-2), no CDN request. Lazy so the map code stays out of the first chunk;
// window.L is kept because ToDo's deck layers read it.
let _leafletPromise = null
export function loadLeaflet() {
  if (window.L) return Promise.resolve(window.L)
  if (!_leafletPromise) {
    _leafletPromise = Promise.all([import('leaflet'), import('leaflet/dist/leaflet.css')])
      .then(([m]) => { window.L = m.default || m; return window.L })
  }
  return _leafletPromise
}
